import { BASE_URL } from '@helpers/constants'
import { getBrowserName, getBrowserVersion } from '@helpers/osInfo'
import setAuthorization from '@helpers/setAuthorization'
import {
	LoginRequest,
	LoginResponse,
	signUpRequest,
	signUpResponse,
	recoveryResponse,
	recoveryRequest,
	changePasswordResponse,
	changePasswordRequest,
	migrationVideoRequest,
	ChangePasswordWithDocResponse,
	ChangePasswordWithDocRequest,
	SendMagicLoginResponse,
	SendMagicLoginRequest,
	MagicLoginResponse,
	MagicLoginRequest,
} from '@models/auth.model'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const authApi = createApi({
	reducerPath: 'authApi',
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: (headers, { endpoint, getState }) => {
			if (
				endpoint.includes('/login') ||
				endpoint.includes('changePasswordWithDoc') ||
				endpoint.includes('sendMagicLogin') ||
				endpoint.includes('magicLogin')
			) {
				headers.delete('Authorization')

				return headers
			}

			const newHeaders = setAuthorization(headers, { getState, endpoint })

			return newHeaders
		},
	}),
	endpoints: (builder) => ({
		authenticate: builder.mutation<LoginResponse, LoginRequest>({
			query: (userCredentials) => ({
				url: '/login',
				method: 'POST',
				body: {
					...userCredentials,
					platform: getBrowserName(navigator.userAgent),
					version: getBrowserVersion(navigator.userAgent),
				},
				headers: {
					platform: 'web',
				},
			}),
		}),
		signUp: builder.mutation<signUpResponse, signUpRequest>({
			query: (userCredentials) => ({
				url: '/register',
				method: 'POST',
				body: userCredentials,
			}),
		}),
		recovery: builder.mutation<recoveryResponse, recoveryRequest>({
			query: (userCredentials) => ({
				url: '/recover-password?sendLink=1',
				method: 'POST',
				body: userCredentials,
			}),
		}),
		changePassword: builder.mutation<
			changePasswordResponse,
			changePasswordRequest
		>({
			query: (userCredentials) => ({
				url: '/change-password',
				method: 'PUT',
				body: userCredentials,
			}),
		}),
		migrationLink: builder.mutation<void, migrationVideoRequest>({
			query: (token) => ({
				url: '/email-migration',
				method: 'POST',
				body: token,
			}),
		}),
		changePasswordWithDoc: builder.mutation<
			ChangePasswordWithDocResponse,
			ChangePasswordWithDocRequest
		>({
			query: (payload) => ({
				url: '/change-password-with-doc',
				method: 'PUT',
				body: payload,
			}),
		}),
		sendMagicLogin: builder.mutation<
			SendMagicLoginResponse,
			SendMagicLoginRequest
		>({
			query: (payload) => ({
				url: '/send-magic-login',
				method: 'POST',
				body: payload,
			}),
		}),
		magicLogin: builder.mutation<MagicLoginResponse, MagicLoginRequest>({
			query: (payload) => ({
				url: '/magic-login',
				method: 'POST',
				body: payload,
			}),
		}),
		// profile: builder.mutation<ProfileResponse, void>({
		// 	query: () => ({
		// 		url: `/profile`,
		// 		method: 'GET',
		// 	}),
		// }),
	}),
})
